import ProductsAllView from './ProductsAllView'

export default ProductsAllView
